import { Component, Input } from '@angular/core';
import { JsonParams } from './../../../foundations-webct-robot/robot/classes/jsonParams.class';

@Component({
    selector: 'progressbar-component',
    templateUrl: 'progressbar.component.html'
})

export class ProgressbarComponent {

    @Input() public inputParameters: JsonParams;
}
